import styled from 'styled-components';
import { GridRow, HeaderGridRow } from 'ui/indexPages/tables/grid';
import { LinkButton } from 'ui/linkButton';
import { PopoverContent } from 'ui/popover';
import { WebLink2, body2, colors, fontWeights, heading4, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledTakeoverMainHeader = styled.div`
  ${heading4}
  font-weight: ${fontWeights.bold};
  color: ${colors.white};
`;

export const StyledFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${spacing.base};
`;

export const ChooseCampaignBodyWrapper = styled.div`
  padding: ${spacing.plusHalf};
  display: flex;
  flex-direction: column;
  min-width: ${pxToRem(1187)};
`;

export const TakeoverBodyLabel = styled.div`
  ${heading4}
`;

export const SearchWrapper = styled.div`
  padding: ${spacing.plusHalf} 0;
  display: flex;
  justify-content: flex-end;
`;

export const BaseCellWrapper = styled.div<{ $isDisabled?: boolean }>`
  ${body2}
  align-items: center;
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap;
  color: ${({ $isDisabled }) => ($isDisabled ? colors.textDisabled : colors.textPrimary)};
  padding: 0 ${spacing.base};
`;

export const CampaignNameWrapper = styled(BaseCellWrapper)`
  color: ${colors.textPrimary};
`;

export const BodyText = styled.span`
  ${body2}
`;

export const NameLabelLink = styled(WebLink2)`
  text-decoration: none;
`;

export const CellPadding = styled.div`
  padding-left: ${spacing.base};
  padding-right: ${spacing.base};
  width: 100%;
`;

export const InPageHeaderGridRow = styled(HeaderGridRow)`
  padding: ${spacing.base};
  column-gap: 0;
  border: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.quarter} ${spacing.quarter} 0 0;
  align-items: center;
`;

export const InPageGridRow = styled(GridRow)`
  padding: ${spacing.base};
  column-gap: 0;
`;

export const TableContentWrapper = styled.div`
  border: ${spacing.single} solid ${colors.grey15};
  border-top: none;
  border-radius: 0 0 ${spacing.quarter} ${spacing.quarter};
  padding-bottom: ${spacing.base};
`;

export const ChooseCampaignButton = styled(LinkButton)`
  width: ${pxToRem(146)};
`;

export const StyledExperimentPopoverContent = styled(PopoverContent)`
  padding: ${spacing.half} ${spacing.base} ${spacing.base};
`;

export const DetailSpacer = styled.span`
  padding: 0 ${spacing.half};
  color: ${colors.grey35};
`;
